import React from "react";
import NonSubLockBox from "./NonSubLockBox";
import { Panel } from "../ui";

// The Insights tab of the client dashboard.
//
// INT-015 (Backend#136): there is no market card. It rendered AI-generated
// figures ("+0.88% S&P 500", "X% this quarter") as if they were market data.
// It is removed rather than relabelled, and the market array is never read
// even if an old stored document still carries it.
//
// SEC-025: with the AI kill switch off, `GET /insights/latest` answers `null`,
// so empty is an expected state, not an error.
//
// Rendered inside the dashboard's <TabsContent value="Insights">.

export const INSIGHTS_DISCLAIMER = "Educational information, not financial advice.";
export const INSIGHTS_EMPTY_COPY = "No insights to show yet. Check back later.";

const ROW_CLASS =
  "tw-border-0 tw-border-b tw-border-solid tw-border-divider tw-py-3 last:tw-border-b-0";

export function normalizeInsights(payload) {
  const list = payload?.financialInsights;
  if (!Array.isArray(list)) return [];
  return list.filter((item) => item && typeof item === "object" && (item.title || item.description));
}

export default function InsightsPanel({ financialInsights, subscribed }) {
  const items = Array.isArray(financialInsights) ? financialInsights : [];

  return (
    <Panel title="AI Financial Insights" className="tw-relative tw-overflow-hidden">
      <p className="tw-m-0 tw-mb-3 tw-text-sm tw-text-text-muted">{INSIGHTS_DISCLAIMER}</p>
      <div className="tw-max-h-96 tw-overflow-y-auto">
        {items.length > 0 ? (
          items.map((item, index) => (
            <div key={item._id || `insight-${index}`} className={ROW_CLASS}>
              {item.title && <h3 className="tw-m-0 tw-text-sm tw-font-bold tw-text-text">{item.title}</h3>}
              {item.description && (
                <p className="tw-m-0 tw-mt-1 tw-text-sm tw-text-text-muted">{item.description}</p>
              )}
            </div>
          ))
        ) : (
          <p className="tw-m-0 tw-text-sm tw-text-text-muted">{INSIGHTS_EMPTY_COPY}</p>
        )}
      </div>
      {!subscribed && <NonSubLockBox className="tw-rounded-lg" />}
    </Panel>
  );
}
